import { type CountryCode, type ProjectCode } from '@constants'
import { useFastpassMerchantGoogleAnalyticEvent } from '@dni-analysis'
import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Footer, type FooterProps } from '@pets-ui/Footer/Footer'
import { HStack } from '@pets-ui/HStack/HStack'
import { Coupon } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { DIALOG_COUPON, DialogCoupon } from '../DialogCoupon/DialogCoupon'
const styles = stylex.create({
  button: {
    borderColor: colors.grey300,
    justifyContent: 'flex-start',
    width: '100%',
  },
  footer: {
    alignItems: 'center',
    display: 'flex',
    height: 56,
  },
})
export interface FooterCouponProps extends FooterProps {
  campaignId: number
  campaignCode?: string
  currency?: string
  projectCode: ProjectCode
  countryCode: CountryCode
}

export const FooterCoupon = (props: FooterCouponProps) => {
  const { campaignCode, campaignId, projectCode, currency, countryCode, ...rest } = props
  const { openDialog: openDialogCoupon } = useDialog(DIALOG_COUPON)
  const { sendClickCouponEvent, sendOpenPromotionPopupEvent } = useFastpassMerchantGoogleAnalyticEvent({ projectCode, countryCode, campaignId })

  const handleDialogCouponClick = () => {
    openDialogCoupon()
    sendClickCouponEvent()
    sendOpenPromotionPopupEvent()
  }

  return (
    <>
      <DialogCoupon campaignCode={campaignCode} campaignId={campaignId} projectCode={projectCode} countryCode={countryCode} currency={currency} />
      <Footer {...rest} rootStyle={[styles.footer]}>
        <HStack justifyContent="space-between" alignItems="center" width="100%">
          <HStack gap={2}>
            <VStack justifyContent="center">
              <Coupon />
            </VStack>
            <Text>優惠折扣</Text>
          </HStack>
          <HStack justifyContent="flex-end">
            <Button
              fullWidth
              variant="text"
              color="blue"
              rootStyle={[styles.button]}
              onClick={handleDialogCouponClick}
            >
              <Text variant="body" color={colors.blue600}>查看或使用優惠</Text>
            </Button>
          </HStack>
        </HStack>
      </Footer>
    </>
  )
}
